module.exports = __webpack_public_path__ + "static/media/puzzle.6a028ffd.png";